import axios from 'axios';
import { Cookie, Dater } from '@/utils';

export const Token = {
    get: () =>
    {
        const accessToken = Cookie.get(process.env.VUE_APP_ACCESS_TOKEN_STORAGE);

        return accessToken;
    },

    set: (data) =>
    {
        if (data.access_token && data.refresh_token)
        {
            Cookie.set(process.env.VUE_APP_ACCESS_TOKEN_STORAGE, data.access_token, Dater.secToDays(data.expires_in));
            Cookie.set(process.env.VUE_APP_REFRESH_TOKEN_STORAGE, data.refresh_token, Dater.secToDays(data.expires_in));

            axios.defaults.headers.common.Authorization = `${data.token_type} ${data.access_token}`;
        }
    },

    destroy: () =>
    {
        Cookie.delete(process.env.VUE_APP_ACCESS_TOKEN_STORAGE);
        Cookie.delete(process.env.VUE_APP_REFRESH_TOKEN_STORAGE);
        delete axios.defaults.headers.common.Authorization;
    },
};
